export default __webpack_public_path__ + "static/media/download.fa9b61dc.svg";